import { render, staticRenderFns } from "./VerificationStatus.vue?vue&type=template&id=346632d9&"
import script from "./VerificationStatus.vue?vue&type=script&lang=js&"
export * from "./VerificationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports